module.exports = __webpack_public_path__ + "../static/img/brasil.643db80c.png";